/*
 * @Author: liuziwei
 * @Date: 2023-08-07 14:37:35
 * @LastEditTime: 2023-08-23 14:20:03
 * @LastEditors: liuziwei
 * @Description: 券浮层 - 券 item 组件
 * 睡觉了, 帮我关一下月亮 🌙  ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ
 */
<template minapp='mpx' xlang='wxml'>
  <!-- 领域展开 -->
  <view class="coupon-item-container">
    <!-- 信息展示部分 -->
    <view class="coupon-info-area">
      <!-- 券优惠信息 -->
      <view class="left-area">
        <view class="amount-area">
          <text wx:if="{{displayedInfo.amount}}" class="amount">{{ displayedInfo.amount }}</text>
          <text wx:if="{{displayedInfo.unit}}" class="unit">{{ displayedInfo.unit }}</text>
        </view>
        <text wx:if="{{displayedInfo.maxAmount}}" class="confine-text">
          {{ displayedInfo.maxAmount }}
        </text>
      </view>
      <!-- 券详情介绍 -->
      <view class="right-area">
        <!-- 券名称 -->
        <text wx:if="{{couponInfo.name}}" class="name">{{ couponInfo.name }}</text>
        <!-- 到期时间 -->
        <text wx:if="{{displayedInfo.expiredTime}}" class="expire-time-text">
          {{ displayedInfo.expiredTime }}
        </text>
        <!-- 券介绍 -->
        <text wx:if="{{couponInfo.remark}}" class="remark">{{ couponInfo.remark }}</text>
      </view>
    </view>
    <!-- 券状态部分 -->
    <view
      class="coupon-status-area coupon-status-area-cyber"
      style="{{statusColor}}"
      bindtap="tapActivity"
      wx:if="{{couponInfo.txt}}"
    >
      <view class="arrow">{{ couponInfo.txt }}</view>
    </view>
    <view class="coupon-status-area" style="{{statusColor}}" bindtap="tapCoupon" wx:else>
      {{ couponStatusInfo.text }}
    </view>
  </view>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'
  import { couponStatusConf } from '@/config/coupon'
  import { goTo } from '@didi/webx-js'
  import { isWXMini, isALIMini } from '@/common/constant'
  import { debounce } from '@/utils'

  createComponent({
    props: {
      couponData: {
        type: Object,
        value: () => {}
      }
    },
    computed: {
      // 券信息
      couponInfo() {
        return this.couponData?.coupon_info || {}
      },
      // 优惠信息
      displayedInfo() {
        return this.couponInfo?.displayedInfo || {}
      },
      // 券状态信息
      couponStatusInfo() {
        return this.couponInfo?.couponStatusInfo || {}
      },
      // 券状态对应颜色
      statusColor() {
        return `color: ${this.couponStatusInfo.color}`
      },
      isMiniH5() {
        return isWXMini || isALIMini
      }
    },
    methods: {
      // 点击领券
      tapCoupon() {
        // 上报事件
        this.triggerEvent('receiveSingleCoupon', {
          coupon: this.couponData?.coupon_info,
          receiveUrl: this.couponData?.receive_url ?? ''
        })
      },
      // 点击跳转活动页
      tapActivity: debounce(
        function () {
          // const url = this.isMiniH5 ? this.couponInfo.toUrlMiniH5 : this.couponInfo.toUrl
          goTo({
            url: this.couponInfo.toUrl
          })
          // if(this.isMiniH5) {
          //   goTo({
          //     path: this.couponInfo.toUrlMiniH5
          //   })
          // } else {
          //   goTo({
          //     url: this.couponInfo.toUrl
          //   })
          // }
        },
        500,
        true
      )
    }
  })
</script>

<style lang='stylus' scoped>
  .coupon-item-container
    position relative
    border-radius 10px
    background #FFF6F1
    height 82px
    display flex
    align-items center
    justify-content space-between
    margin-bottom 10px
    // 替换成 drop-shadow
    -webkit-mask radial-gradient(circle at calc(100% - 94px) 5px, transparent 5px, #000 0) 0px -5px
    mask radial-gradient(circle at calc(100% - 94px) 5px, transparent 5px, #000 0) 0px -5px
    &:last-child
      margin-bottom 0
    .coupon-info-area
      height 100%
      display flex
      align-items center
      justify-content center
      .left-area
        width 90px
        display flex
        flex-shrink 0
        flex-direction column
        align-items center
        .amount-area
          display flex
          align-items baseline
          justify-content center
          .amount, .unit
            font-weight 600
            color #F86316
          .amount
            font-family Barlow Semi Condensed
            font-size 35px
            line-height 35px
            font-weight 400
          .unit
            font-family PingFang SC
            font-size 14px
            line-height 15px
        .confine-text
          font-family PingFang SC
          font-size 10px
          font-weight 400
          line-height 10px
          color #B69786
          margin-top 5px
      .right-area
        display flex
        flex-direction column
        .name
          font-family PingFang SC
          font-size 15px
          font-weight 600
          line-height 15px
          color #333
          margin-bottom 7px
        .expire-time-text, .remark
          font-family PingFang SC
          font-size 10px
          font-weight 400
          line-height 13px
          color #B69786
          padding-right 5px
        .expire-time-text
          margin-bottom 5px
    .coupon-status-area
      flex-shrink 0
      width 94px
      height 61px
      display flex
      align-items center
      justify-content center
      border-left 1px dashed rgba(248, 99, 22, 0.3)
      font-family PingFang SC
      font-size 15px
      font-weight 500
      line-height 15px
      color #F86316
      &-cyber
        font-size 14px
    .arrow
      position relative
      &::after
        content ''
        top 6px
        right -5px
        position absolute
        width 2px
        height 2px
        border-top 1.5px solid
        border-right 1.5px solid
        transform rotate(45deg)
</style>

<script name='json'>
  module.exports = {
    usingComponents: {}
  }
</script>
